import React from 'react';
import { motion } from 'framer-motion';

export const containerVariants = {
    closed: {
        border: '1px solid rgba(142, 157, 185, 0)',
        transition: {
            when: 'afterChildren',
        },
    },
    open: {
        border: '1px solid rgba(142, 157, 185, 1)',
        transition: {
            when: 'beforeChildren',
        },
    },
};

export const ctaVariants = {
    closed: {
        transition: {
            duration: 0.25,
            delay: 0.2,
        },
        transitionEnd: {
            display: 'block',
        },
    },
    open: {
        display: 'none',
        transition: {
            duration: 0.05,
        },
    },
};

export const editorVariants = {
    closed: {
        border: '1px solid rgba(142, 157, 185, 0)',
        transitionEnd: {
            display: 'none',
        },
        transition: {
            delay: 0.1,
            duration: 0.2,
        },
    },
    open: {
        display: 'block',
        border: '1px solid rgba(142, 157, 185, 1)',
        transition: {
            delay: 0,
            duration: 0.2,
        },
    },
};

export const buttonPanelVariants = {
    closed: {
        opacity: 0,
        height: 0,
        transition: {
            delay: 0,
            duration: 0.25,
        },
        transitionEnd: {
            display: 'none',
        },
    },
    open: {
        opacity: 1,
        height: 'auto',
        display: 'block',
        transition: {
            delay: 0,
            duration: 0.25,
        },
    },
};

export const AnimationWrapper = React.memo(
    ({
        component: Component,
        variants,
        className = '',
        initial = 'closed',
        animate = 'open',
        ...rest
    }) => {
        return (
            <motion.div
                className={className}
                variants={variants}
                initial={initial}
                animate={animate}
            >
                <Component {...rest} />
            </motion.div>
        );
    }
);
